import { render, staticRenderFns } from "./BillInpatient.vue?vue&type=template&id=8e7731cc&"
import script from "./BillInpatient.vue?vue&type=script&lang=js&"
export * from "./BillInpatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports